module.exports = __webpack_public_path__ + "static/32-7c51da75c85fd58b2962790d1fde7a41.png";